import { propertyAccessor } from '../../common/components/properties/Properties'
import { XlsxColumn } from '../../common/components/export/ExportService'

export function shipmentMaterialsXlsxColumns(packlistNumber: string): XlsxColumn[] {
  return [
    {
      header: 'Packlist',
      toStringFunction: () => packlistNumber,
    },
    {
      header: 'Material Code',
      toStringFunction: propertyAccessor('productCode'),
    },
    {
      header: 'Size',
      toStringFunction: propertyAccessor('sizeCode'),
    },
    {
      header: 'Division',
      toStringFunction: propertyAccessor('divisionCode'),
    },
    {
      header: 'Total Units',
      toStringFunction: propertyAccessor('quantity'),
    },
    {
      header: 'Delivery Note',
      toStringFunction: propertyAccessor('deliveryNoteNumber'),
    },
    {
      header: 'SO Number',
      toStringFunction: propertyAccessor('salesOrderNumber'),
    },
    {
      header: 'PO Number',
      toStringFunction: propertyAccessor('purchaseOrderNumber'),
    },
    {
      header: 'Customer PO Number',
      toStringFunction: propertyAccessor('customerPurchaseOrderNumber'),
    },
    {
      header: 'Upc',
      toStringFunction: propertyAccessor('upc'),
    },
  ]
}
